import { BaseApi } from '@/core/api/base.api'
import { Room } from "@/core/api/room.api";
import { roomNoteService } from "@/core/service/room.note.service";

class RoomNoteApi extends BaseApi {
  constructor() {
    super();
    Room.Note = this;

    Room.ready(e => {
      this._eventListen(this.#Events);
    });
  }

  #Events = {}

  async saveNote(params) {
    return (await roomNoteService.saveNote(params)).data.data;
  }

  async editNote(params) {
    return (await roomNoteService.editNote(params)).data.data;
  }

  async getNotes() {
    return (await roomNoteService.getNotes()).data.data;
  }

  async getNote() {
    return (await roomNoteService.getNote()).data.data;
  }
}

export const RoomNote = new RoomNoteApi();
